class Handler {
    constructor() {
        this._Handler = null;
    }
    setHandler(handler) {
        this._Handler = handler;
    }
    getHandler() {
        return this._Handler;
    }
}
class DatePickerDropDownHandler extends Handler {
}
export const datePickerDropDownHandler = new DatePickerDropDownHandler();
class ButtonsPopupHandler extends Handler {
}
export const buttonsPopupHandler = new ButtonsPopupHandler();
class PopupErrorHandler extends Handler {
}
export const popupErrorHandler = new PopupErrorHandler();
class MessageBoxHandler extends Handler {
}
export const messageBoxHandler = new MessageBoxHandler();
class ConfirmationScreenHandler extends Handler {
}
export const confirmationScreenHandler = new ConfirmationScreenHandler();
class GenerateReportMessageHandler extends Handler {
}
export const generateReportMessageHandler = new GenerateReportMessageHandler();
class RiskWarningMessageScreenHandler extends Handler {
}
export const riskWarningMessageScreenHandler = new RiskWarningMessageScreenHandler();
class BrokerMessageScreenHandler extends Handler {
}
export const brokerMessageScreenHandler = new BrokerMessageScreenHandler();
class AlertMessageScreenHandler extends Handler {
}
export const alertMessageScreenHandler = new AlertMessageScreenHandler();
class WorkspaceManagerHandler extends Handler {
}
export const workspaceManagerHandler = new WorkspaceManagerHandler();
class PositionExerciseRequestScreenHandler extends Handler {
}
export const positionExerciseRequestScreenHandler = new PositionExerciseRequestScreenHandler();
class PositionsMutualCloseScreenHandler extends Handler {
}
export const positionsMutualCloseScreenHandler = new PositionsMutualCloseScreenHandler();
class ModifyOrderScreenHandler extends Handler {
}
export const modifyOrderScreenHandler = new ModifyOrderScreenHandler();
class EditPositionScreenHandler extends Handler {
}
export const editPositionScreenHandler = new EditPositionScreenHandler();
class ExternalScreenHandler extends Handler {
}
export const externalScreenHandler = new ExternalScreenHandler();
class EntitlementSubscribeDocumentScreenHandler extends Handler {
}
export const entitlementSubscribeDocumentScreenHandler = new EntitlementSubscribeDocumentScreenHandler();
class TerceraNumericHandler extends Handler {
}
export const terceraNumericHandler = new TerceraNumericHandler();
class PropertySetupScreenForIndicatorHandler extends Handler {
}
export const propertySetupScreenForIndicatorHandler = new PropertySetupScreenForIndicatorHandler();
class AddOverlayScreenHandler extends Handler {
}
export const addOverlayScreenHandler = new AddOverlayScreenHandler();
class MultiComboBoxPopupMenuHandler extends Handler {
}
export const multiComboBoxPopupMenuHandler = new MultiComboBoxPopupMenuHandler();
